module.exports = __webpack_public_path__ + "img/l.8a5cb2af.jpg";